export default "__VITE_ASSET__nQG7gkSx__"